<template>
  <div class="input-group date date-picker">
    <span v-if="displayNextPrevious" class="input-group-btn">
      <button class="btn blue" type="button" tabindex="-1" @click="previousDay" :class="buttonClasses" :disabled="disabled">
        <i class="fa fa-arrow-left"></i>
      </button>
    </span>
    <input :name="name" type="text" :value="value" @change="onChange" ref="date-picker" class="no-focus form-control form-control-inline input_placeholder" :class="inputClasses" :placeholder="placeholder" :disabled="disabled" />
    <span v-if="displayNextPrevious" class="input-group-btn">
      <button class="btn blue" type="button" tabindex="-1" @click="nextDay" :class="buttonClasses" :disabled="disabled">
        <i class="fa fa-arrow-right"></i>
      </button>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    placeholderFormat: {
      type: String,
      required: false
    },
    size: {
      type: String,
      default: "medium"
    },
    displayNextPrevious: {
      type: Boolean,
      default: false
    },
    value: {},
  },
  data() {
    return {
      datePicker: undefined,
    };
  },
  computed: {
    buttonClasses() {
      switch(this.size){
        case "small":
          return ['btn-sm']
      } 
    },
    inputClasses() {
      switch(this.size){
        case "small":
          return ['input-sm', 'input-small2']
      } 
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let _this = this;
      let input = this.$refs["date-picker"];
      this.datePicker = $(input).datepicker({
        rtl: App.isRTL(),
        orientation: "right",
        format: this.placeholderFormat ?? "yyyy-mm-dd",
        autoclose: true,
        todayHighlight: true,
        todayBtn: "linked"
      });

      this.datePicker.on("changeDate", (e) => {
        _this.$emit("input", input.value);
        _this.$emit("change", input.value);
      });
    },
    onChange(event) {
      this.$emit("input", input.value);
      this.$emit("change", input.value);
    },
    previousDay() {
      let input = this.$refs["date-picker"];
      let date = $(input).datepicker("getDate");
      let newdate = date.addDays(-1);
      $(input).datepicker("setDate", newdate);
    },
    nextDay() {
      let input = this.$refs["date-picker"];
      let date = $(input).datepicker("getDate");
      let newdate = date.addDays(1);
      $(input).datepicker("setDate", newdate);
    },
  },
};
</script>

<style lang="scss" scoped>
.input-small2 {
  width: 90px!important;
}
</style>